import React from 'react';

import { SvgIcon, SvgIconProps } from '@mui/material';

export const DictationMicrophoneIcon: React.FC<SvgIconProps> = (props) => {
  return (
    <SvgIcon {...props} viewBox="0 0 20 20">
      <path
        d="M10 12.5A2.5 2.5 0 0 0 12.5 10V5a2.5 2.5 0 1 0-5 0v5A2.5 2.5 0 0 0 10 12.5Z"
        fill="none"
        stroke="currentColor"
        strokeLinecap="round"
        strokeLinejoin="round"
        strokeWidth="1.5"
      />
      <path
        d="M5.5 9.5A4.5 4.5 0 0 0 10 14a4.5 4.5 0 0 0 4.5-4.5M10 14v3M7.5 17h5"
        fill="none"
        stroke="currentColor"
        strokeLinecap="round"
        strokeLinejoin="round"
        strokeWidth="1.5"
      />
    </SvgIcon>
  );
};

export const DictationStopIcon: React.FC<SvgIconProps> = (props) => {
  return (
    <SvgIcon {...props} viewBox="0 0 20 20">
      <rect
        x="5.5"
        y="5.5"
        width="9"
        height="9"
        rx="2"
        fill="none"
        stroke="currentColor"
        strokeLinecap="round"
        strokeLinejoin="round"
        strokeWidth="1.5"
      />
    </SvgIcon>
  );
};
